import BaseModel from '../vendor/baseModel'

export class CrossSell extends BaseModel {
  constructor(args) {
    super({
      url: 'cross_sell_items',
      name: 'crossSell',
      page_size: 'all',
      text: args?.text ?? {}
    })
  }
}
